import Button from '@material-ui/core/Button';
import { BACKGROUND_TYPES, BackgroundContainer } from 'components/Background';
import React from 'react';
import Text from 'components/base/Text';
import SunglassesDudesWithBooks from 'images/characters/sunglasses-dudes-with-books.svg';
import Icon from 'components/base/Icon';
import { Flex, Padding } from 'components/base/layout-components';
import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
import AppRouter from 'common/AppRouter';

const GroupAllTeamsEmptyState = ({ history }) => {
  const myAccount = useSelector(myAccountSelector);
  const isAccountAdmin = myAccount?.type_id === ACCOUNT_TYPES_MAP.Primary;
  return (
    <>
      <BackgroundContainer
        justify='center'
        type={BACKGROUND_TYPES.EMPTY_DASHBOARD}
        items='center'
      >
        <Flex direction='column' pt='1rem'>
          <Flex justify='center'>
            <img src={SunglassesDudesWithBooks} alt='' />
          </Flex>
          <Flex direction='column' items='center'>
            <Text pt='1.5rem' size='x-x-x-large' weight='300'>
              Get a deeper perspective on
            </Text>
            <Text pt='0.5rem' size='x-x-x-large' weight='300'>
              your team's performance
            </Text>

            <Text pt='3rem' size='large' weight='300'>
              start by creating groups and teams.
            </Text>
            <Text pt='0.5rem' size='large' weight='300'>
              you may get your org structure from GitHub, or define it manually
            </Text>

            {isAccountAdmin && (
              <Padding padding='large'>
                <Button
                  size='large'
                  variant='contained'
                  onClick={() => {
                    history.push({
                      pathname: AppRouter.TEAMS_SETTINGS.path,
                      search: '?isOrgSettings=true'
                    });
                  }}
                >
                  <Icon
                    name='settings'
                    color='white'
                    style={{ paddingRight: '0.6rem' }}
                  />{' '}
                  Go to Company Settings
                </Button>
              </Padding>
            )}
          </Flex>
        </Flex>
      </BackgroundContainer>
    </>
  );
};

export default GroupAllTeamsEmptyState;
